var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyLocation = function SvgMyLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 16.8h16v16H16v-16z",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 22.1c-1.5 0-2.7 1.2-2.7 2.7s1.2 2.7 2.7 2.7 2.7-1.2 2.7-2.7-1.2-2.7-2.7-2.7zm6 2c-.3-2.8-2.5-5-5.3-5.3v-1.4h-1.3v1.4c-2.8.3-5 2.5-5.3 5.3h-1.4v1.3H18c.3 2.8 2.5 5 5.3 5.3v1.4h1.3v-1.4c2.8-.3 5-2.5 5.3-5.3h1.4v-1.3H30zm-6 5.3c-2.6 0-4.7-2.1-4.7-4.7S21.4 20 24 20s4.7 2.1 4.7 4.7-2.1 4.7-4.7 4.7z"
  })));
};
export default SvgMyLocation;